module.exports = __webpack_public_path__ + "img/1.14d8d7e1.png";